<div class="cart-page">
  <app-site-header />

  <main class="cart-main">
    <div class="kota-container cart-main__inner">
      @if (items().length === 0) {
        <div class="cart-empty">
          <p class="cart-empty__title">Tu carrito está vacío</p>
          <a routerLink="/catalogo" class="cart-empty__btn">Ir al catálogo</a>
        </div>
      } @else {
        <div class="cart-layout kota-enter-seq">
          <section class="cart-items kota-enter-stagger" aria-labelledby="cart-heading">
            <div class="cart-items__head">
              <h1 id="cart-heading" class="cart-items__title">Tu Carrito ({{ itemCount() }})</h1>
              <button type="button" class="cart-items__clear" (click)="clearCart()">Vaciar carrito</button>
            </div>

            @for (line of items(); track line.id) {
              <article class="cart-line" [class.cart-line--removing]="cartService.isRemoving(line.id)">
                <img [src]="line.image" [alt]="line.name" class="cart-line__img" width="120" height="120" loading="lazy" />
                <div class="cart-line__info">
                  <h2 class="cart-line__name">{{ line.name }}</h2>
                  <p class="cart-line__desc">{{ line.description }}</p>
                  <p class="cart-line__price">{{ formatMoney(line.unitPrice) }}</p>
                </div>
                <div class="cart-line__qty" role="group" [attr.aria-label]="'Cantidad de ' + line.name">
                  <button
                    type="button"
                    class="cart-line__qty-btn"
                    (click)="dec(line.id)"
                    [disabled]="cartService.isRemoving(line.id)"
                    aria-label="Reducir cantidad"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <path d="M5 12h14" />
                    </svg>
                  </button>
                  <span class="cart-line__qty-val">{{ line.qty }}</span>
                  <button
                    type="button"
                    class="cart-line__qty-btn"
                    (click)="inc(line.id)"
                    [disabled]="cartService.isRemoving(line.id)"
                    aria-label="Aumentar cantidad"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <path d="M12 5v14M5 12h14" />
                    </svg>
                  </button>
                </div>
                <button
                  type="button"
                  class="cart-line__remove"
                  (click)="remove(line.id)"
                  [disabled]="cartService.isRemoving(line.id)"
                  [attr.aria-busy]="cartService.isRemoving(line.id)"
                  [attr.aria-label]="cartService.isRemoving(line.id) ? 'Eliminando artículo' : 'Eliminar artículo'"
                >
                  @if (cartService.isRemoving(line.id)) {
                    <span class="cart-line__spinner" aria-hidden="true"></span>
                  } @else {
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                      <line x1="10" x2="10" y1="11" y2="17" />
                      <line x1="14" x2="14" y1="11" y2="17" />
                    </svg>
                  }
                </button>
              </article>
            }
          </section>

          <aside class="cart-summary" aria-labelledby="summary-heading">
            <h2 id="summary-heading" class="cart-summary__title">Resumen del Pedido</h2>
            <div class="cart-summary__rows">
              <div class="cart-summary__row">
                <span>Subtotal</span>
                <span>{{ formatMoney(subtotal()) }}</span>
              </div>
              <div class="cart-summary__row">
                <span>Envío</span>
                <span class="cart-summary__free">{{ shippingLabel() }}</span>
              </div>
              <div class="cart-summary__divider"></div>
              <div class="cart-summary__row cart-summary__row--total">
                <span>Total</span>
                <span>{{ formatMoney(total()) }}</span>
              </div>
            </div>

            <div class="cart-summary__promo">
              <input
                type="text"
                class="cart-summary__promo-input"
                placeholder="Código de descuento"
                name="promo"
                [(ngModel)]="promo"
              />
              <button type="button" class="cart-summary__promo-btn" (click)="applyPromo()">Aplicar</button>
            </div>

            <a routerLink="/pago" class="cart-summary__checkout">
              Proceder al Pago
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>

            <p class="cart-summary__secure">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <path d="m9 12 2 2 4-4" />
              </svg>
              Pago 100% seguro
            </p>
          </aside>
        </div>
      }
    </div>
  </main>
</div>
